import { render, staticRenderFns } from "./BookableCreate.vue?vue&type=template&id=58b23e89&scoped=true"
import script from "./BookableCreate.vue?vue&type=script&lang=js"
export * from "./BookableCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b23e89",
  null
  
)

export default component.exports